import { Button as AppButton } from 'global/components/Button';
import { Dialog, FormControl, IconButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RoundedCorners = styled(ToggleButtonGroup)(({ theme }) => ({
  borderRadius: 50,
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
}));

export const IconSpacing = styled('span')(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

export const DialogText = styled(Dialog)({
  textAlign: 'left',
});

export const TitleContainer = styled('div')({
  margin: '0 auto',
  maxWidth: 640,
});

export const BottomSpacing = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(1),
}));

export const ToggleLabel = styled('label')(({ theme }) => ({
  top: -21,
  left: -14,
  fontSize: 12,
  color: theme.palette.secondary.main,
  flexDirection: 'row',
  alignItems: 'center',
  display: 'flex',
}));

export const SubScoreFormPadding = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const ToggleFormControl = styled(FormControl)(({ theme }) => ({
  paddingTop: 20,
  width: '100%',

  '& .jbuilderGroup': {
    '& .jbuilderCol': {
      flex: 1,

      '& .jbuilderErrorText': {
        color: theme.palette.error.main,
      },

      '& .MuiFormControl-root': {
        width: '100%',

        '& .MuiInputBase-root': {
          height: 56,
        },
      },
    },
  },
}));

export const BtnSave = styled(AppButton)({
  display: 'flex',
  justifySelf: 'center',
});
